import { BaseUseCase } from "../UseCaseBase";
class InvestorUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getInvestorData();
    }
}
export default InvestorUseCase;
